/** Stored in `app_theme_customization.fontId`; omit or use this to keep the base theme font. */
export const THEME_DEFAULT_FONT_ID = 'theme-default';
const SANS_FALLBACK = [
    'ui-sans-serif',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    'sans-serif',
];
/** UI font choices. Add bundled fonts under `apps/web/public/fonts/` (see README there). */
export const APP_FONT_OPTIONS = [
    {
        id: THEME_DEFAULT_FONT_ID,
        label: 'Theme default',
        typography: { fontFamily: [] },
    },
    {
        id: 'inter',
        label: 'Inter',
        typography: {
            fontFamily: ['Inter', ...SANS_FALLBACK],
            googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap',
        },
    },
    {
        id: 'system',
        label: 'System UI',
        typography: {
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                'Helvetica',
                'Arial',
                'sans-serif',
            ],
        },
    },
    {
        id: 'jetbrains-mono',
        label: 'JetBrains Mono',
        typography: {
            fontFamily: ['"JetBrains Mono"', ...SANS_FALLBACK],
            googleFontsUrl: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;600;700&display=swap',
        },
    },
    {
        id: 'crimson-pro',
        label: 'Crimson Pro',
        typography: {
            fontFamily: ['"Crimson Pro"', ...SANS_FALLBACK],
            googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@400;500;600;700&display=swap',
        },
    },
    {
        id: 'custom',
        label: 'Custom (Disenchantment.ttf)',
        typography: {
            fontFamily: ['Disenchantment', ...SANS_FALLBACK],
            localFont: {
                family: 'Disenchantment',
                src: '/fonts/Disenchantment.ttf',
                format: 'truetype',
            },
        },
    },
];
const fontById = new Map(APP_FONT_OPTIONS.map((f) => [f.id, f]));
export function listAppFontOptions() {
    return APP_FONT_OPTIONS.map(({ id, label }) => ({ id, label }));
}
export function getAppFontOption(fontId) {
    if (!fontId || fontId === THEME_DEFAULT_FONT_ID)
        return null;
    return fontById.get(fontId) ?? null;
}
export function isValidAppFontId(fontId) {
    return fontById.has(fontId);
}
/** Applies a font preset onto resolved theme typography (mutates `theme.typography`). */
export function applyFontOptionToTypography(typography, fontId) {
    const option = getAppFontOption(fontId);
    if (!option || option.id === THEME_DEFAULT_FONT_ID || option.typography.fontFamily.length === 0) {
        return;
    }
    typography.fontFamily = [...option.typography.fontFamily];
    if (option.typography.googleFontsUrl) {
        typography.googleFontsUrl = option.typography.googleFontsUrl;
    }
    else {
        delete typography.googleFontsUrl;
    }
    if (option.typography.localFont) {
        typography.localFont = { ...option.typography.localFont };
    }
    else {
        delete typography.localFont;
    }
}
//# sourceMappingURL=app-fonts.js.map